"use client";
import { Box, Typography, Stack } from "@mui/material";
import { Create } from "@mui/icons-material";
import React from "react";

interface ContentCreatedSlideProps {
  data: {
    workouts: number;
    checkIns: number;
    lessons: number;
    habits: number;
  };
  year: number;
}

export default function ContentCreatedSlide({
  data,
  year,
}: ContentCreatedSlideProps) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#0a0a0a",
        position: "relative",
        color: "white",
        p: 4,
        textAlign: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "50%",
          background:
            "linear-gradient(to bottom, rgba(16, 185, 129, 0.2), transparent)",
          pointerEvents: "none",
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1, width: "100%" }}>
        <Create
          sx={{
            fontSize: 60,
            mb: 3,
            color: "#10b981",
          }}
        />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            mb: 4,
            animation: "fadeIn 0.5s ease-out",
            "@keyframes fadeIn": {
              "0%": { opacity: 0 },
              "100%": { opacity: 1 },
            },
          }}
        >
          Content Created in {year}
        </Typography>
        <Box
          sx={{
            width: "100%",
            maxWidth: 600,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
            },
            gap: 3,
          }}
        >
          {/* Workouts */}
          <Box
            sx={{
              bgcolor: "rgba(16, 185, 129, 0.1)",
              border: "2px solid rgba(16, 185, 129, 0.3)",
              borderRadius: 3,
              p: 3,
              animation: "slideInRight 0.5s ease-out 0.2s both",
              "@keyframes slideInRight": {
                "0%": {
                  transform: "translateX(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Typography variant="h2" sx={{ fontWeight: 900, color: "#10b981" }}>
              {data.workouts}
            </Typography>
            <Typography variant="h6">Workouts</Typography>
          </Box>
          <Box
            sx={{
              bgcolor: "rgba(16, 185, 129, 0.1)",
              border: "2px solid rgba(16, 185, 129, 0.3)",
              borderRadius: 3,
              p: 3,
              animation: "slideInRight 0.5s ease-out 0.4s both",
              "@keyframes slideInRight": {
                "0%": {
                  transform: "translateX(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Typography variant="h2" sx={{ fontWeight: 900, color: "#10b981" }}>
              {data.checkIns}
            </Typography>
            <Typography variant="h6">Check-ins</Typography>
          </Box>
          <Box
            sx={{
              bgcolor: "rgba(16, 185, 129, 0.1)",
              border: "2px solid rgba(16, 185, 129, 0.3)",
              borderRadius: 3,
              p: 3,
              animation: "slideInRight 0.5s ease-out 0.6s both",
              "@keyframes slideInRight": {
                "0%": {
                  transform: "translateX(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Typography variant="h2" sx={{ fontWeight: 900, color: "#10b981" }}>
              {data.lessons}
            </Typography>
            <Typography variant="h6">Lessons</Typography>
          </Box>
          <Box
            sx={{
              bgcolor: "rgba(16, 185, 129, 0.1)",
              border: "2px solid rgba(16, 185, 129, 0.3)",
              borderRadius: 3,
              p: 3,
              animation: "slideInRight 0.5s ease-out 0.6s both",
              "@keyframes slideInRight": {
                "0%": {
                  transform: "translateX(50px)",
                  opacity: 0,
                },
                "100%": {
                  transform: "translateX(0)",
                  opacity: 1,
                },
              },
            }}
          >
            <Typography variant="h2" sx={{ fontWeight: 900, color: "#10b981" }}>
              {data.habits}
            </Typography>
            <Typography variant="h6">Habits</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
